import { addDataLayerEvent } from '../services/dataLayer'
import userService, { state } from '../services/user'
import { generateUuid } from './uuid-generator'

function addUserIdEvent (userId) {
  addDataLayerEvent({ event: 'user id', value: userId })
}

export function addUserIdDataLayerEvent () {
  state.isUserAuthorized && userService.fetchUserInfo().then(user => {
    if (!user.uuid) {
      const newUuid = generateUuid()

      userService.setUserId(newUuid).then(() => addUserIdEvent(newUuid))
    } else addUserIdEvent(user.uuid)
  })
}
